<template>
  <div class="toast-panel">
    <div v-for="t in toast.items" :key="t.id" class="toast-item" :class="t.type">
      <div class="toast" :class="t.type">
        <button class="close" @click="toast.remove(t.id)" aria-label="Close"></button>
        <h3>{{ titleFor(t) }}</h3>
        <p>{{ t.text }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useToast } from '../ui/toast'
const toast = useToast()
function titleFor(t) {
  if (t.title) return t.title
  if (t.type === 'error') return 'خطا!'
  if (t.type === 'warning') return 'هشدار!'
  if (t.type === 'success') return 'موفق!'
  return 'راهنما!'
}
</script>

<script>
export default { name: 'ToastNotify' }
</script>


<style scoped>
:root {
  --tr: all 0.5s ease 0s;
}
.toast-panel { position: fixed; top: 16px; right: 16px; display:flex; flex-direction: column; gap: 12px; z-index: 1000; }
.toast-item { max-height: 25rem; transition: var(--tr); position: relative; animation: show-toast 4s ease 0s 1; }
@keyframes show-toast { 
  0%, 50%, 100% { max-height: 0; opacity: 0; }
  10%, 25% { max-height: 15rem; opacity: 1; }
}
.toast { background:#fff; color:#111827; padding: 1rem 3rem 1rem 2rem; border-radius: 1rem; position: relative; font-weight: 300; margin: 0.25rem 0; text-align: right; max-width: 22rem; transition: var(--tr); opacity: 1; border: 0.15rem solid #fff2; box-shadow: 0 0 1.5rem 0 #1a1f4360; }
.toast:before { content: ""; position: absolute; width: 0.5rem; height: calc(100% - 1.5rem); top: 0.75rem; right: 0.5rem; z-index: 0; border-radius: 1rem; background: var(--clr); }
.toast h3 { font-size: 1.1rem; margin: 0; line-height: 1.35rem; font-weight: 700; position: relative; color: var(--clr); }
.toast p { position: relative; font-size: 0.95rem; z-index: 1; margin: 0.25rem 0 0; color: #595959; line-height: 1.3rem; }
.close { position: absolute; width: 1.35rem; height: 1.35rem; text-align: center; left: 1rem; cursor: pointer; border-radius: 100%; border:none; background:transparent; }
.close:after { position: absolute; width: 100%; height: 100%; left: 0; font-size: 1.6rem; content: "+"; transform: rotate(-45deg); border-radius: 100%; display: flex; align-items: center; justify-content: center; color: #595959; }
.close:hover:after { background: var(--clr); color: #fff; }
.toast-item.help { --clr: #0070e0; }
.toast-item.success { --clr: #03a65a; }
.toast-item.warning { --clr: #fc8621; }
.toast-item.error { --clr: #db3056; }
</style>
